import React, { useContext, useEffect, useState } from "react";
import style from "../styles/register.module.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import StateContext from "../context/state/StateContext";
import UserContext from "../context/user/UserContext";
import axios from "axios";

const Register = () => {
  const { user, StoreToken, verifyUser, user_verified } = useContext(UserContext);
  const { setLoading } = useContext(StateContext);
  const [select, setSelect] = useState("");
  const [formData, setFormData] = useState({
    username: "",
    name: "",
    email: "",
    phone: "",
    password: "",
  });
  const [drop, setDrop] = useState(false);
  const [error, setError] = useState("");
  const [company, setCompany] = useState(false);

  const navigate = useNavigate();

  const selectDrop = (select) => {
    setSelect(select);
    setDrop(false);
  };

  const token = localStorage.getItem("token");

    const verifyAndRedirect = async () => {
      setLoading({ open: true, text: 'Verifying...' });

      const result = await verifyUser(); // Call the function from context
      if (result?.success) {
          if (user?.verified === false) {
              navigate('/'); // Redirect if the user is not verified
          } else {
              if(user?.role !== "admin"){
                navigate('/dashboard'); // Redirect if the user is not verified
              }
          }
      } else {
          toast.error("Verification failed. Redirecting to login.");
          navigate('/'); // Redirect on failure
      }

      setLoading({ open: false, text: '' });
  };

  useEffect(() => {
      if(token){
          verifyAndRedirect();
      }
  }, []);

  const handleChange = (e) => {
    setError("");
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [showPassword, setShowPassword] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    StoreToken();
    try {
      setError("");
      setLoading({ open: true, text: "Creating" });
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "api/auth/createUser",
        {
          role: select,
          username: formData.username,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
        },
        {
          headers: {
            "Content-type": "application/json",
            "auth-token": `${localStorage.getItem("token")}`,
          },
        }
      );

      const json = response.data;
      console.log(json);
      if (json.success) {
        console.log("Successfully Created");
        toast.success("SuccessFully Created");
      } else {
        console.log(json.error);
        setError(json.message || json.message[0].msg);
        console.log("Some error Occurred");
      }
    } catch (error) {
      console.log(error);
      setError(
        error.response.data.error ||
          error.message ||
          error.response.data.message ||
          error.response.data.message[0].path
      );
      console.log("Some Thing Went wrong");
    } finally {
      setLoading({ open: false, text: "" });
    }
  };

  return (
    <>
      <div className={`container-fluid ${style.register} py-4`}>
        <div className="row">
          <h2 className="text-white">
            <Link to="/dashboard">Go to Dashboard</Link>
          </h2>
          <div className="col-lg-7 col-12 d-flex justify-content-center align-items-center flex-column">
            <div className={`"container-fluid" ${style.box}`}>
              <div className="row">
                <div className="col-lg-12">
                  <h1 className="text-center">Register</h1>
                  <div className={style.formstart}>
                    <Loading />
                    <form className={style.signup_form} onSubmit={handleSubmit}>
                      <div
                        className={` ${style.dropdown} ${
                          drop ? style.active : ""
                        }`}
                        onClick={() => setDrop(!drop)}
                      >
                        <div className={style.select}>
                          <div className="d-flex align-items-center">
                            <i className="bx bx-user-circle"></i>
                            <span>
                              {select
                                ? select === "Employee"
                                  ? "Team Member"
                                  : select === "agency" ? "Agency User" : select
                                : "Select Role"}
                            </span>
                          </div>
                          <i className="fa-solid fa-angle-up"></i>
                        </div>
                        <ul>
                          <li
                            onClick={() => {
                              selectDrop("HOD");
                            }}
                          >
                            HOD
                          </li>
                          <li
                            onClick={() => {
                              selectDrop("Employee");
                            }}
                          >
                            Team Member
                          </li>
                          <li
                            onClick={() => {
                              selectDrop("agency");
                            }}
                          >
                            Agency User
                          </li>
                        </ul>
                      </div>
                      <div className={style.inputField}>
                        <i className="bx bx-user"></i>
                        <input
                          type="text"
                          id="username"
                          name="username"
                          onChange={handleChange}
                          className=""
                          placeholder="Username"
                          required
                        />
                      </div>
                      <div className={style.inputField}>
                        <i className="bx bx-user"></i>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          onChange={handleChange}
                          className=""
                          placeholder={company ? "Company Name" : "Full Name"}
                          required
                        />
                      </div>
                      <div className={style.inputField}>
                        <i className="bx bx-envelope"></i>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          onChange={handleChange}
                          className=""
                          placeholder="Email"
                          required
                        />
                      </div>
                      <div className={style.inputField}>
                        <i className="bx bx-phone"></i>
                        <input
                          type="text"
                          id="phone"
                          name="phone"
                          onChange={handleChange}
                          className=""
                          maxLength={10}
                          placeholder="Phone"
                          required
                          pattern="[0-9]{10}"
                        />
                      </div>
                      <div
                        className={`${style.inputField} mb-0 position-relative`}
                      >
                        <i className="bx bx-lock-alt"></i>
                        <input
                          type={showPassword ? "password" : "text"}
                          id="password"
                          name="password"
                          onChange={handleChange}
                          placeholder="Password"
                          className=""
                          required
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: "99999",
                          }}
                        >
                          {showPassword ? (
                            <i className="bx bx-hide"></i> // Eye icon for hidden password
                          ) : (
                            <i className="bx bx-show"></i> // Eye icon for visible password
                          )}
                        </span>
                      </div>
                      <p style={{ color: "red", marginBottom: "0px" }}>
                        {error}
                      </p>
                      <button
                        type="submit"
                        className={`"btn btn-block" ${style.bttn1}`}
                      >
                        Register
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-12"></div>
        </div>
      </div>
    </>
  );
};

export default Register;
